import { atom } from 'recoil';

export const refreshDeductibleOptionsAtom = atom({
    key: 'refreshDeductibleOptionsAtom',
    default: {}
});
